import axios from './_axios_config';
import { request, buildQuery } from './_process_request';

export const ct_expenses = {
    async getExpenses(params) {
        return request(axios.get(`/expenses${buildQuery(params)}`));
    },

    async getCategories() {
        return request(axios.get('/expenses/categories'));
    },

    async createExpense(data) {
        return request(axios.post('/expenses', data));
    },

    async updateExpense(id, data) {
        return request(axios.put(`/expenses/${id}`, data));
    },

    async deleteExpense(id) {
        return request(axios.delete(`/expenses/${id}`));
    },
};
